import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltOffIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M22.0452 3.03613L15.0012 10.0801H15.0198L13.5793 11.5205H13.5608L11.8254 13.2549L11.8206 13.2783L9.7229 15.376L9.72681 15.3535L2.96997 22.1113L1.69751 20.8389L8.67603 13.8604H3.25024L13.0901 2.66016H15.55L14.3606 8.1748L20.7727 1.76367L22.0452 3.03613ZM10.9104 21.2803H8.45044L9.02271 18.6221L11.1028 16.542L10.47 19.4199L17.3704 11.5205H16.1252L17.5657 10.0801H20.7502L10.9104 21.2803ZM6.63013 12.4199H10.1165L12.2649 10.2705L13.5305 4.52051L6.63013 12.4199Z" />
    </SvgIcon>
  );
});
